<!-- Toast notifications -->
<p-toast key="delete_webhook"></p-toast>
<p-toast key="switch-webhook-success" position="top-right"></p-toast>
<p-toast key="switch-webhook-error" position="top-right"></p-toast>

<!-- Modern Header Section -->
<div class="m-4">
  <div class="webhook-admin-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="webhook-admin-title">
          <i class="pi pi-link mr-3"></i>
          Webhook Administration
        </h1>
        <p class="webhook-admin-subtitle">
          Manage and monitor webhooks submitted by users
        </p>
      </div>
      <div class="header-right">
        <button
          pButton
          pRipple
          label="Assign Webhooks"
          icon="pi pi-user-plus"
          class="modern-button assign-button"
          (click)="showAssignSection = !showAssignSection"
        ></button>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="webhook-admin-content">
  <!-- Assign Webhooks Section -->
  <div *ngIf="showAssignSection" class="assign-webhooks-section">
    <div class="assign-section-header">
      <div class="assign-header-content">
        <div class="assign-header-left">
          <h2 class="assign-section-title">
            <i class="pi pi-user-plus mr-2"></i>
            Assign Webhooks to User
          </h2>
          <p class="assign-section-subtitle">
            Select webhooks and assign them to a user account
          </p>
        </div>
        <button
          pButton
          pRipple
          icon="pi pi-times"
          class="close-assign-button"
          (click)="showAssignSection = false"
          title="Close"
        ></button>
      </div>
    </div>

    <div class="assign-section-content">
      <!-- User Selection -->
      <div class="assign-form-section">
        <div class="form-field">
          <label class="field-label">
            <i class="pi pi-user mr-2"></i>
            Select User
          </label>
          <p-dropdown
            [options]="users"
            [(ngModel)]="selectedUser"
            optionLabel="username"
            placeholder="Choose a user..."
            [showClear]="true"
            class="modern-dropdown"
            styleClass="modern-dropdown"
            (onChange)="onUserChange()"
          >
            <ng-template let-user pTemplate="selectedItem">
              <div class="user-dropdown-item" *ngIf="user">
                <i class="pi pi-user mr-2"></i>
                <span>{{ user.username }}</span>
              </div>
            </ng-template>
            <ng-template let-user pTemplate="item">
              <div class="user-dropdown-item">
                <i class="pi pi-user mr-2"></i>
                <span>{{ user.username }}</span>
                <span class="user-email">{{ user.email }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>

      <!-- Available Webhooks List -->
      <div class="assign-form-section">
        <div class="section-header-small">
          <h3 class="section-title-small">
            <i class="pi pi-list mr-2"></i>
            Available Webhooks
          </h3>
          <p class="section-description-small">
            Select one or more webhooks to assign to the selected user
          </p>
        </div>

        <div class="webhooks-selection-container">
          <!-- Search/Filter -->
          <div class="webhook-search">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                type="text"
                pInputText
                placeholder="Search webhooks..."
                [(ngModel)]="webhookSearchTerm"
                class="modern-input"
              />
            </span>
          </div>

          <!-- Webhooks List -->
          <div class="webhooks-checkbox-list">
            <div
              *ngFor="let webhook of filteredAvailableWebhooks"
              class="webhook-checkbox-item"
            >
              <div class="webhook-checkbox-card">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="webhook.selected"
                  [inputId]="'webhook-' + webhook.id"
                  class="webhook-checkbox"
                ></p-checkbox>
                <label
                  [for]="'webhook-' + webhook.id"
                  class="webhook-checkbox-label"
                >
                  <div class="webhook-checkbox-content">
                    <div class="webhook-checkbox-header">
                      <h4 class="webhook-checkbox-name">
                        <i class="pi pi-link mr-2"></i>
                        {{ webhook.webhook_name }}
                      </h4>
                    </div>
                    <div class="webhook-checkbox-details">
                      <p class="webhook-checkbox-url">
                        <i class="pi pi-globe mr-1"></i>
                        {{ webhook.webhook_url }}
                      </p>
                      <p class="webhook-checkbox-description" *ngIf="webhook.description">
                        {{ webhook.description }}
                      </p>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <!-- Empty State for Available Webhooks -->
            <div *ngIf="filteredAvailableWebhooks.length === 0" class="no-webhooks-message">
              <i class="pi pi-info-circle"></i>
              <p>No available webhooks found</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="assign-section-actions">
        <button
          pButton
          pRipple
          label="Cancel"
          icon="pi pi-times"
          class="modern-button cancel-button"
          (click)="showAssignSection = false"
        ></button>
        <button
          pButton
          pRipple
          label="Assign Selected Webhooks"
          icon="pi pi-check"
          class="modern-button primary"
          [disabled]="!selectedUser || !hasSelectedWebhooks()"
          (click)="assignWebhooks()"
        ></button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-content">
      <p-progressSpinner
        strokeWidth="3"
        animationDuration=".5s"
        styleClass="loading-spinner"
      ></p-progressSpinner>
      <p class="loading-text">Loading webhooks...</p>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && userWebhooks.length == 0" class="empty-state-container">
    <div class="empty-state-card">
      <div class="empty-content">
        <i class="pi pi-info-circle empty-icon"></i>
        <h3>No Webhooks Found</h3>
        <p>No webhooks have been created from any accounts yet</p>
      </div>
    </div>
  </div>

  <!-- Webhooks Content -->
  <div *ngIf="!loading && userWebhooks.length > 0" class="content-section">
    <div *ngFor="let userWebhook of userWebhooks; index as i" class="user-webhook-section">
      <!-- User Header -->
      <div class="user-header">
        <div class="user-header-content">
          <div class="user-icon">
            <i class="pi pi-user"></i>
          </div>
          <div class="user-info">
            <h2 class="user-name">{{ userWebhook.user_details?.username }}'s Webhooks</h2>
            <p class="webhook-count">{{ userWebhook.webhooks.length }} webhook{{ userWebhook.webhooks.length !== 1 ? 's' : '' }}</p>
          </div>
        </div>
      </div>

      <!-- Webhooks Grid -->
      <div class="webhooks-grid">
        <div
          *ngFor="let webhook of userWebhook.webhooks"
          class="webhook-card"
        >
          <div class="webhook-card-header">
            <div class="webhook-icon">
              <i class="pi pi-link"></i>
            </div>
            <h3 class="webhook-name">{{ webhook.webhook_name }}</h3>
          </div>

          <div class="webhook-card-content">
            <div class="webhook-field">
              <label class="field-label">
                <i class="pi pi-globe mr-2"></i>
                Webhook URL
              </label>
              <p class="field-value" [innerHTML]="webhook.webhook_url"></p>
            </div>

            <div class="webhook-field" *ngIf="webhook.description">
              <label class="field-label">
                <i class="pi pi-file-edit mr-2"></i>
                Description
              </label>
              <p class="field-value" [innerHTML]="webhook.description"></p>
            </div>
          </div>

          <div class="webhook-card-actions">
            <button
              pButton
              pRipple
              label="Submit"
              icon="pi pi-upload"
              class="modern-button primary"
              (click)="openDialog(webhook)"
            ></button>
            <button
              pButton
              pRipple
              label="Delete"
              icon="pi pi-trash"
              class="modern-button danger"
              (click)="deleteWebhook(webhook)"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog header="Delete"></p-confirmDialog>
